import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import { useParams } from "react-router-dom";
import { A5PortfoliosEditCard } from "./edit_card";

export const A5PortfoliosEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <A5PortfoliosEditCard
          id={Number(id)}
          client={Clients.A5}
          table_name={`${Tables.A5_PORTFOLIOS}`}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.A5}
          audit_table_name={`${Tables.A5_PORTFOLIOS}`}
        />
      </div>
    </div>
  );
};
